import { FIREFLY_TARGET_ATTR } from "@/lib/firefly/fireflyTargetConvention";

export function ActivityDockOpenQcSection(props: {
  items: ReadonlyArray<{
    id: string;
    description: string;
    serial_text: string | null;
    session_id: string;
    category_id?: string | null;
    category_name?: string | null;
    item_title?: string | null;
  }> | null;
  onOpenBuilderAssistant?: (sessionId?: string, categoryId?: string | null) => void;
}) {
  const items = props.items ?? [];
  if (items.length === 0) return null;
  return (
    <section
      aria-label="Open QC items"
      {...{ [FIREFLY_TARGET_ATTR]: "open-qc-inbox" }}
      className="mt-3 rounded-lg border border-amber-300 bg-amber-50 p-3 dark:border-amber-500/60 dark:bg-amber-950/30"
    >
      <h3 className="text-[11px] font-semibold uppercase tracking-wide text-amber-900 dark:text-amber-200">
        Open QC
      </h3>
      <ul className="mt-2 space-y-1 text-[12px] text-amber-950 dark:text-amber-100">
        {items.slice(0, 8).map((item) => {
          const place = [item.serial_text, item.category_name, item.item_title].filter(Boolean).join(" · ");
          return (
            <li key={item.id}>
              <button
                type="button"
                className="text-left underline decoration-amber-700/40"
                onClick={() => props.onOpenBuilderAssistant?.(item.session_id, item.category_id)}
              >
                {place || item.description.slice(0, 120)}
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
